import { Component, OnInit, OnDestroy, Input } from '@angular/core'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { CheckoutService } from '../../checkout.service'
import { Subscription } from 'rxjs'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { take } from 'rxjs/operators'
import { CommonService } from '../../../../../../shared/services/common.service'
import { VS_LAUNCH_CALLER } from '../../../../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-billing-details',
  templateUrl: './billing-details.component.html',
  styleUrls: ['./billing-details.component.scss'],
})
export class BillingDetailsComponent implements OnInit, OnDestroy {
  fetchedCartReviewOrder: any
  fileSizeInfo: any
  fileshow: any
  public hideTrasnportion: boolean
  cartId: string
  activeCartIdSubscription: Subscription
  @Input() placeOrderStatus: boolean
  @Input() isAdditionalType: boolean
  orderStatus: boolean = false
  constructor(
    public commonService: CommonService,
    public activeCartService: ActiveCartFacade,
    private checkoutService: CheckoutService,
    private launchDialogService: LaunchDialogService,
    private globalMessageService: GlobalMessageService
  ) {}
  ngOnChanges(changes) {
    if (
      changes?.placeOrderStatus?.currentValue !=
      changes?.placeOrderStatus?.previousValue
    ) {
      this.orderStatus = changes?.placeOrderStatus?.currentValue
    }
  }
  ngOnDestroy(): void {
    if (this.activeCartIdSubscription) {
      this.activeCartIdSubscription.unsubscribe()
    }
  }

  openOrderReviewModal() {
    const componentdata = {
      isAdditionalType: this.isAdditionalType,
    }

    const orderReviewDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.ORDER_REVIEW,
      undefined,
      undefined,
      componentdata
    )
    if (orderReviewDialog) {
      orderReviewDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }

    this.checkoutService.storePlaceOrderStatus.subscribe((data) => {
      this.orderStatus = data
    })
  }

  getFile() {
    // const urlparams = ['users', 'current', 'vscart', this.cartId];
    // const apiUrl = this.commonService.constructUrl(urlparams);
    // this.commonService.getData(apiUrl)
    this.checkoutService.getCartReviewOrderResponse.subscribe(
      (data) => {
        this.fetchedCartReviewOrder = data

        if (
          this.fetchedCartReviewOrder?.freightTermCode == 'Prepay_ADD' ||
          this.fetchedCartReviewOrder?.freightTermCode == '0003'
        ) {
          this.hideTrasnportion = true
        } else {
          this.hideTrasnportion = false
        }

        for (
          let i = 0;
          i <= this.fetchedCartReviewOrder.poAttachments?.length;
          i++
        ) {
          if (
            this.fetchedCartReviewOrder.poAttachments[i] !== null ||
            this.fetchedCartReviewOrder.poAttachments[i] !== undefined
          ) {
            this.fileshow =
              (
                Math.round(
                  this.fetchedCartReviewOrder.poAttachments[i].attachmentSizes /
                    1024
                ) / 1024
              ).toFixed(2) + ' mb'
            this.fetchedCartReviewOrder.poAttachments[i].attachmentSizes.push(
              this.fileshow
            )
          }
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  ngOnInit(): void {
    this.orderStatus = this.placeOrderStatus
    this.hideTrasnportion = false
    this.activeCartIdSubscription = this.activeCartService
      .getActiveCartId()
      .subscribe((success) => {
        if (success) {
          this.cartId = success
          this.getFile()
        }
      })
  }

  convertFileRetain(data) {
    let returnVal
    returnVal = (data / (1024 * 1024)).toFixed(2)
    if (returnVal > 1) {
      return returnVal + 'mb'
    } else {
      return (data / 1024).toFixed(2) + 'kb'
    }
  }

  getFileSize(fileSize) {
    if (Math.round((fileSize / 1024) * 1000) / 1000 >= 1024.0) {
      return (Math.round(fileSize / 1024) / 1024).toFixed(2) + ' mb'
    }
    if (Math.round((fileSize / 1024) * 1000) / 1000 < 1024.0) {
      return (Math.round((fileSize / 1024) * 1000) / 1000).toFixed(2) + ' kb'
    }
  }

  getCouponDiscout() {
    if (this.fetchedCartReviewOrder?.productCouponDiscount?.value > 0) {
      return this.fetchedCartReviewOrder.productCouponDiscount?.formattedValue
    }
    return this.fetchedCartReviewOrder?.orderDiscounts?.formattedValue
  }
}
